import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { Icon } from '../../../../components/Component';
import TotalTenantSalesChart from './TotalTenantSalesChart';

const TotalTenantSales = ({ sales }) => {

  const [sales_data, setSalesData] = useState(sales);

  useEffect(() => {
    setSalesData(sales);
  }, [sales]);


  return (
    <>
      <Card className=" h-100">
        <div className="nk-ecwg nk-ecwg1">
          <div className="card-inner">
            <div className="card-title-group">
              <div className="card-title">
                <h6 className="title">Total Orders</h6>
              </div>
            </div>
            <div className="data">
              <div className="amount">{sales_data?.total_orders || "0"}</div>
              <div className="info">
                <strong>{sales_data?.total_orders_previous_month || "0"}</strong> in last month
              </div>
            </div>
            <div className="data">
              <h6 className="sub-title">This week so far</h6>
              <div className="data-group">
                <div className="amount">{sales_data?.total_tenant_orders_current_week || "0"}</div>
                <div className="info text-end">
                  {
                    sales_data?.rise_fall === "fall" ?
                      <>
                        <span className="change down">
                          <Icon name="arrow-long-down"></Icon>{sales_data?.percentage_change ? parseFloat(sales_data?.percentage_change)?.toFixed(2) : ""}%
                        </span>
                      </>
                      :
                      <>
                        <span className="change up">
                          <Icon name="arrow-long-up"></Icon>{sales_data?.percentage_change ? parseFloat(sales_data?.percentage_change)?.toFixed(2) : ""}%
                        </span>
                      </>
                  }
                  <br />
                  <span>vs. last week</span>
                </div>
              </div>
            </div>
          </div>
          <div style={{ height: "150px" }}>
            <TotalTenantSalesChart sales={sales_data?.orders_grouped_by_date} />
          </div>
        </div>
      </Card>
    </>
  );
};

export default TotalTenantSales;